import { vendors, logFactory, components } from "GlobalSite";

const compName = "preview_page_template_solutions_my-wealthplanning_page";
const Log = logFactory(compName);
const { log } = Log;

const {
  compTechGenericModal: { openDialog },
} = components;

log("--->");

const {
  jquery: { $ },
} = vendors;

$(function domReady() {
  const $contactDialog = $("#contactDialog");
  const $restartDialog = $("#restartDialog");

  $(document)
    .on("click", ".js-modal-contact", function (event) {
      event.preventDefault();
      openDialog($contactDialog);
    })
    .on("click", "#restart_dialog_form", function (event) {
      event.preventDefault();
      openDialog($restartDialog);
    });
});
